import script from "./BaseDivider.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseDivider.vue?vue&type=script&setup=true&lang=js"

import "./BaseDivider.vue?vue&type=style&index=0&id=70d72e03&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-70d72e03"]])

export default __exports__